module.exports = __webpack_public_path__ + "media/images/emoticons/pocketbell-08d84f458800047a49f532161e50bffc.gif";